document.addEventListener("DOMContentLoaded", function () {
  const utilityBar = document.querySelector(".utility-bar.color-scheme-5.gradient");
  const menuList = document.getElementById("HeaderMenu-MenuList-1");
 
  if (!utilityBar || !menuList) return;
 
  const utilityBarHeight = 38;
 
  window.addEventListener("scroll", function () {
    if (window.scrollY > utilityBarHeight) {
      // Utility bar is hidden
      menuList.classList.add("height-adjust");
    } else {
      // Utility bar is visible
      menuList.classList.remove("height-adjust");
    }
  });
});